<template>
    <div
        class="form-toast"
        :class="{ 'toast-mark': showMark }"
        :style="{
            backgroundColor: markBgColor,
            '--g-btn-background': globalBackgroundColor
        }"
        v-show="isShow"
    >
        <div class="toast-wrapper">
            <div class="toast-icon">
                <i class="iconfont" :class="[icon]" :style="iconStyle"></i>
            </div>
            <div class="toast-content">
                <slot name="content">{{ content }}</slot>
            </div>
            <div class="toast-footer" v-show="showFooter">
                <slot name="footer">
                    <input
                        v-if="isMobile"
                        type="button"
                        class="toast-btn toast-btn2"
                        :value="confirmButtonText"
                        :style="{
                            backgroundColor: confirmButtonStyle.backgroundColor,
                            borderColor: confirmButtonStyle.backgroundColor
                        }"
                        @click="handleConfirm"
                    />
                    <input
                        type="button"
                        class="toast-btn toast-btn1"
                        :value="cmpCancelButtonText"
                        :style="cancelButtonStyle"
                        @click="handleCancel"
                    />
                    <input
                        v-if="!isMobile"
                        type="button"
                        class="toast-btn toast-btn2"
                        :value="cmpConfirmButtonText"
                        :style="{
                            backgroundColor: confirmButtonStyle.backgroundColor,
                            borderColor: confirmButtonStyle.backgroundColor
                        }"
                        @click="handleConfirm"
                    />
                </slot>
            </div>
        </div>
    </div>
</template>
<script>
import util from '@/common/util';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
export default {
    emits: ['update:visible', 'cancel', 'confirm'],
    i18next: {
        ns: 'md-form'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        showMark: {
            type: Boolean,
            default: true
        },
        markBgColor: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: 'icon-success'
        },
        content: {
            type: String,
            default: "Thanks! I'll get back to you shortly."
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        cancelButtonText: {
            type: String
        },
        confirmButtonText: {
            type: String
        },
        cancelButtonStyle: {
            type: Object,
            default: () => ({})
        },
        confirmButtonStyle: {
            type: Object,
            default: () => ({})
        },
        duration: {
            type: Number,
            default: 0
        },
        iconStyle: {
            type: Object,
            default: () => ({})
        }
    },
    data: function() {
        return {
            isShow: false
        };
    },
    computed: {
        ...mapState(usePageStore, {
            globalBackgroundColor: store =>
                store.page.themeRootVar['--g-btn-background']
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        cmpCancelButtonText() {
            return this.cancelButtonText ?? this.$t('md-form.cancelButtonText');
        },
        cmpConfirmButtonText() {
            return (
                this.confirmButtonText ?? this.$t('md-form.confirmButtonText')
            );
        }
    },
    watch: {
        visible(val) {
            this.isShow = val;
            if (val) {
                util.enableScroll(false);
                !util.inCms && this.autoClose();
            } else {
                util.enableScroll(true);
            }
        }
    },
    methods: {
        close: function() {
            this.isShow = false;
            util.enableScroll(true);
            this.$emit('update:visible', false);
        },
        autoClose() {
            if (this.duration > 0) {
                this.timer = setTimeout(() => {
                    this.close();
                }, this.duration);
            }
        },
        handleCancel: function() {
            this.close();
            this.$emit('cancel');
        },
        handleConfirm: function() {
            this.$emit('confirm');
        }
    },
    beforeUnmount() {
        clearTimeout(this.timer);
    }
};
</script>
<style lang="scss">
@import '../theme/mixin.scss';
.form-toast {
    position: fixed;
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &.toast-mark {
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
        background-color: rgba(25, 25, 25, 0.6);
        z-index: var(--level-high);
    }
    .toast-wrapper {
        padding: 50px 30px 30px 30px;
        margin: 0 auto;
        text-align: center;
        box-shadow: 0 4px 10px 0 rgba(170, 186, 218, 0.3);
        background-color: #ffffff;
        > .toast-icon {
            > .iconfont {
                font-size: 60px;
                color: var(--mg-button-background); //follow submit button
            }
        }
        > .toast-content {
            margin: {
                top: 22px;
                bottom: 13px;
            }
            font-size: 18px;
            color: var(--color-text);
        }
        > .toast-footer {
            margin-top: 30px;
            .toast-btn {
                width: 184px;
                height: 50px;
                vertical-align: bottom;
                font-size: 16px;
                &:hover {
                    cursor: pointer;
                }
            }
            .toast-btn1 {
                border: solid 2px #e1e2e6;
                background-color: #ffffff;
                color: var(--color-text);
                margin-right: 20px;
                &:hover {
                    background-color: rgba(225, 226, 230, 0.3);
                }
            }
            .toast-btn2 {
                color: var(--g-btn-color);
                background: var(--g-btn-background);
            }
        }
        @media (max-width: 800px) {
            padding: 30px 15px 15px 15px;
            margin: 0;
            width: 290px;
            > .toast-icon {
                > .iconfont {
                    font-size: 48px;
                }
            }
            .toast-content {
                margin: {
                    top: 10px;
                    bottom: 5px;
                }
                font-size: 16px;
            }
            .toast-footer {
                font-size: 16px;
                margin-top: 15px;
                .toast-btn {
                    width: 100%;
                    height: 40px;
                }
                .toast-btn1 {
                    border: solid 1px #e1e2e6;
                    background-color: #ffffff;
                    margin-top: 15px;
                }
            }
        }
    }
}
</style>
